/* children.svelte.ts generated by Svelte v5.55.3 */
import * as $ from 'svelte/internal/client';
import { db } from "../db";
import { getAppState, setActiveChildId } from "./appState.svelte.ts";

let children = $.state($.proxy([]));

function toPlain(obj) {
	return JSON.parse(JSON.stringify(obj));
}

export function getChildren() {
	return $.get(children);
}

export function getActiveChildren() {
	return $.get(children).filter((c) => !c.archived);
}

export function getArchivedChildren() {
	return $.get(children).filter((c) => c.archived);
}

export function getActiveChildId() {
	return getAppState().activeChildId;
}

export function getActiveChild() {
	const id = getActiveChildId();

	if (!id) return null;

	return $.get(children).find((c) => c.id === id) ?? null;
}

export function getChildById(id) {
	return $.get(children).find((c) => c.id === id);
}

export async function loadChildren() {
	const all = await db.children.orderBy("order").toArray();

	$.set(children, all, true);
}

export async function addChild(input) {
	const now = Date.now();
	const maxOrder = $.get(children).reduce((m, c) => Math.max(m, c.order), -1);

	const entry = {
		id: crypto.randomUUID(),
		name: input.name,
		dateOfBirth: input.dateOfBirth,
		gender: input.gender,
		lastBreastUsed: null,
		lastPumpVolume: null,
		lastBottleVolume: null,
		order: maxOrder + 1,
		createdAt: now,
		updatedAt: now
	};

	await db.children.add(toPlain(entry));
	$.set(children, [...$.get(children), entry], true);

	return entry;
}

export async function updateChild(id, updates) {
	const now = Date.now();

	await db.children.update(id, toPlain({ ...updates, updatedAt: now }));
	$.set(children, $.get(children).map((c) => c.id === id ? { ...c, ...updates, updatedAt: now } : c), true);
}

export async function setActiveChild(id) {
	const child = $.get(children).find((c) => c.id === id);

	if (!child || child.archived) return;

	await setActiveChildId(id);
}

export async function archiveChild(id) {
	const nonArchived = getActiveChildren();

	if (nonArchived.length <= 1 && nonArchived[0]?.id === id) {
		return {
			ok: false,
			error: "Add another child before archiving this one."
		};
	}

	await updateChild(id, { archived: true });

	if (getActiveChildId() === id) {
		const next = getActiveChildren()[0];

		if (next) await setActiveChildId(next.id);
	}

	return { ok: true };
}

export async function restoreChild(id) {
	await updateChild(id, { archived: false });
}

export async function reorderChildren(orderedIds) {
	const now = Date.now();

	for (let i = 0; i < orderedIds.length; i++) {
		await db.children.update(orderedIds[i], { order: i, updatedAt: now });
	}

	await loadChildren();
}

export async function withActiveChild(fn) {
	const id = getActiveChildId();

	if (!id) throw new Error("No active child");

	return fn(id);
}